import { Component, ViewEncapsulation } from "@angular/core";
import { DomainBaseComponent } from "app/shared/domain-base.component";
import { DomainService } from "app/shared/domain.service";

@Component({
  selector: "uni-invoice-pdf-portal-doc",
  standalone: false,
  templateUrl: "./invoice-pdf-portal-doc.component.html",
  encapsulation: ViewEncapsulation.None,
  host: { class: "flex flex-col flex-1 overflow-hidden" },
})
export class InvoicePdfPortalDocComponent extends DomainBaseComponent {
  mdSrc = "/assets/docs/invoice-pdf-portal.md";

  constructor(domainService: DomainService) {
    super(domainService);
    this.isPageReady = true;
  }
}
